;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var Model = APP.module('Model');

	Model.AdCMS = Backbone.Model.extend({

		methodUrl: 'mrecs.json',
		url: function() {
			return this.methodUrl;
		},
	});

}(window, APP, Backbone, Marionette, $, _));